// Cat Breeds card game data with rankings
export const CAT_BREEDS_CARDS = [
  { id: 1, name: "Domestic Shorthair", rank: 1, image: "/images/catBreeds/catBreeds_1.jpg" },
  { id: 2, name: "Domestic Longhair", rank: 2, image: "/images/catBreeds/catBreeds_2.jpg" },
  { id: 3, name: "American Shorthair", rank: 3, image: "/images/catBreeds/catBreeds_3.jpg" },
  { id: 4, name: "Ragdoll", rank: 4, image: "/images/catBreeds/catBreeds_4.jpg" },
  { id: 5, name: "Maine Coon", rank: 5, image: "/images/catBreeds/catBreeds_5.jpg" },
  { id: 6, name: "British Shorthair", rank: 6, image: "/images/catBreeds/catBreeds_6.jpg" },
  { id: 7, name: "Persian", rank: 7, image: "/images/catBreeds/catBreeds_7.jpg" },
  { id: 8, name: "Siamese", rank: 8, image: "/images/catBreeds/catBreeds_8.jpg" },
  { id: 9, name: "Bengal", rank: 9, image: "/images/catBreeds/catBreeds_9.jpg" },
  { id: 10, name: "Abyssinian", rank: 10, image: "/images/catBreeds/catBreeds_10.jpg" },
  { id: 11, name: "Russian Blue", rank: 11, image: "/images/catBreeds/catBreeds_11.jpg" },
  { id: 12, name: "Scottish Fold", rank: 12, image: "/images/catBreeds/catBreeds_12.jpg" },
  { id: 13, name: "Sphynx", rank: 13, image: "/images/catBreeds/catBreeds_13.jpg" },
  { id: 14, name: "Birman", rank: 14, image: "/images/catBreeds/catBreeds_14.jpg" },
  { id: 15, name: "Oriental Shorthair", rank: 15, image: "/images/catBreeds/catBreeds_15.jpg" },
  { id: 16, name: "Devon Rex", rank: 16, image: "/images/catBreeds/catBreeds_16.jpg" },
  { id: 17, name: "Burmese", rank: 17, image: "/images/catBreeds/catBreeds_17.jpg" },
  { id: 18, name: "Siberian", rank: 18, image: "/images/catBreeds/catBreeds_18.jpg" },
  { id: 19, name: "Norwegian Forest Cat", rank: 19, image: "/images/catBreeds/catBreeds_19.jpg" },
  { id: 20, name: "Tonkinese", rank: 20, image: "/images/catBreeds/catBreeds_20.jpg" },
  { id: 21, name: "Exotic Shorthair", rank: 21, image: "/images/catBreeds/catBreeds_21.jpg" },
  { id: 22, name: "Cornish Rex", rank: 22, image: "/images/catBreeds/catBreeds_22.jpg" },
  { id: 23, name: "Himalayan", rank: 23, image: "/images/catBreeds/catBreeds_23.jpg" },
  { id: 24, name: "Ragamuffin", rank: 24, image: "/images/catBreeds/catBreeds_24.jpg" },
  { id: 25, name: "Manx", rank: 25, image: "/images/catBreeds/catBreeds_25.jpg" },
  { id: 26, name: "Turkish Angora", rank: 26, image: "/images/catBreeds/catBreeds_26.jpg" },
  { id: 27, name: "Savannah", rank: 27, image: "/images/catBreeds/catBreeds_27.jpg" },
  { id: 28, name: "Bombay", rank: 28, image: "/images/catBreeds/catBreeds_28.jpg" },
  { id: 29, name: "Egyptian Mau", rank: 29, image: "/images/catBreeds/catBreeds_29.jpg" },
  { id: 30, name: "American Curl", rank: 30, image: "/images/catBreeds/catBreeds_30.jpg" }
];
